module.exports = __webpack_public_path__ + "static/media/bar.64bcf26a.svg";